import { render, staticRenderFns } from "./QAccountGrantsDataTable.vue?vue&type=template&id=5e32d839&scoped=true&"
import script from "./QAccountGrantsDataTable.vue?vue&type=script&lang=js&"
export * from "./QAccountGrantsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QAccountGrantsDataTable.vue?vue&type=style&index=0&id=5e32d839&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32d839",
  null
  
)

export default component.exports